import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { VendorFormWrapperComponent } from '../vendor-form/vendor-form-wrapper.component';

@Component({
  selector: 'app-vendor-add',
  standalone: true,
  imports: [CommonModule, VendorFormWrapperComponent],
  templateUrl: './vendor-add.component.html',
  styleUrl: './vendor-add.component.css',
})
export class VendorAddComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: VendorFormWrapperComponent;

  // This component simply wraps the vendor-form-wrapper in add mode

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}

